import { Component, OnInit } from '@angular/core';
import { UnsubscribeService } from 'src/app/services/unsubscribe.service';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-unsubscribe-success',
  templateUrl: './unsubscribe-success.component.html',
  styleUrls: ['./unsubscribe-success.component.scss']
})
export class UnsubscribeSuccessComponent implements OnInit {
  message: string;

  constructor(private readonly unsubscribeService: UnsubscribeService, private readonly route: Router) { }

  ngOnInit() {
    this.getParamsURL();
  }

  unsubscribeSuccess(param) {
    this.unsubscribeService.confirmedUnsubscribe(param).subscribe(data => {
      if (data.Code === 403) {
        sessionStorage.setItem('e', data.Message);
        this.route.navigateByUrl('/error');
      } else {
        this.message = data.Message;
      }
    },
      error => {
        if (error) {
          sessionStorage.setItem('e', 'Hay algún tipo de problema intentalo más tarde.');
          this.route.navigateByUrl('/error');
        }
      });
  }

  /**
   * recoge parametros en funcion desde donde sea llamado
   */
  getParamsURL() {
    const url = window.location.href;
    const aux = url.split('?p=')[1];
    this.unsubscribeSuccess(aux);
  }

}
